import React, { Component } from 'react';
import { connect } from 'react-redux';

const EVENTO_LABELS = {
  CADASTRO: 'Cadastro',
  INSTALACAO: 'Instalação',
  ALTERACAO: 'Alteração',
  TROCA: 'Troca',
  REMOCAO: 'Remoção',
  DEFEITO: 'Defeito',
  OBSERVACAO: 'Observação',
};

function formatarData(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

class InventarioHistorico extends Component {
  render() {
    const { historico, selected } = this.props;

    if (!selected) {
      return (
        <div className="manutencao-premium-list manutencao-cad-hint">
          Selecione um equipamento na lista para ver o histórico de movimentações.
        </div>
      );
    }

    if (!historico || historico.length === 0) {
      return (
        <div className="manutencao-premium-list manutencao-cad-hint">
          Nenhum evento registrado para o equipamento #{selected.id}.
        </div>
      );
    }

    return (
      <div className="manutencao-premium-list inventario-historico-list">
        <div className="os-relatorio-section-title">
          Histórico — {selected.tipo_nome}
          {selected.etiqueta ? ` (${selected.etiqueta})` : ''}
        </div>
        <div className="inventario-historico-timeline">
          {historico.map(item => (
            <div key={item.id} className="inventario-historico-item">
              <div className="inventario-historico-meta">
                <span className="os-badge os-badge--blue">{EVENTO_LABELS[item.tipo_evento] || item.tipo_evento}</span>
                <span>{formatarData(item.data_evento)}</span>
                {item.usuario_nome && <span>{item.usuario_nome}</span>}
                {item.ordem_servico_numero && <span>OS {item.ordem_servico_numero}</span>}
              </div>
              <p>{item.descricao}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  historico: state.manutencaoInventario.historico,
  selected: state.manutencaoInventario.selected,
});

export default connect(mapStateToProps)(InventarioHistorico);
